import React from 'react';

function Website() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_345)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <rect
            x='20'
            y='22'
            width='40'
            height='5'
            stroke='#FEFEFE'
            stroke-width='1.29167'
          />
          <circle cx='22.8855' cy='24.5' r='0.748096' fill='#FEFEFE' />
          <circle cx='25.5787' cy='24.5' r='0.748096' fill='#FEFEFE' />
          <rect
            x='20'
            y='27'
            width='40'
            height='31'
            stroke='#FEFEFE'
            stroke-width='1.29167'
          />
          <rect x='24.5' y='30.0833' width='16' height='1' stroke='#FEFEFE' />
          <rect
            x='24.6458'
            y='34.8125'
            width='30.7083'
            height='18.7083'
            stroke='#FEFEFE'
            stroke-width='1.29167'
          />
          <path
            d='M32.9218 46.083V44.583L38.9218 41.941V43.6668L34.8139 45.316L34.8693 45.2265V45.4395L34.8139 45.35L38.9218 46.9992V48.725L32.9218 46.083ZM47.0781 46.083L41.0781 48.725V46.9992L45.186 45.35L45.1306 45.4395V45.2265L45.186 45.316L41.0781 43.6668V41.941L47.0781 44.583V46.083Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_345'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_345'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Website;
